var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgDocuments28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1 4.09995C7.1 2.77447 8.17452 1.69995 9.5 1.69995H17.3C17.6183 1.69995 17.9235 1.82638 18.1485 2.05142L24.1485 8.05142C24.3736 8.27647 24.5 8.58169 24.5 8.89995V20.3C24.5 21.6254 23.4255 22.7 22.1 22.7H20.9V23.9C20.9 25.2254 19.8255 26.3 18.5 26.3H5.9C4.57452 26.3 3.5 25.2254 3.5 23.9V7.69995C3.5 6.37447 4.57452 5.29995 5.9 5.29995H7.1V4.09995ZM7.1 7.69995H5.9V23.9H18.5V22.7H9.5C8.17452 22.7 7.1 21.6254 7.1 20.3V7.69995ZM9.5 20.3V4.09995H16.1V7.69995C16.1 9.02543 17.1745 10.1 18.5 10.1H22.1V20.3H9.5ZM20.4029 7.69995H18.5V5.79701L20.4029 7.69995Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocuments28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;